module.exports = __webpack_public_path__ + "img/logo.c797204e.webp";